import { ReactNode, useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"

export type ResponsiveProps = {
  children: ReactNode
}

export type DeviceInfo = {
  isMobile: boolean
  isDesktop: boolean
  isAndroid: boolean
  isIOS: boolean
  userAgent: string
}

export const useDevice = () => {
  const [device, setDevice] = useState<DeviceInfo>({
    isMobile: false,
    isDesktop: true,
    isAndroid: false,
    isIOS: false,
    userAgent: ''
  })

  useEffect(() => {
    const ua = navigator.userAgent
    const isAndroid = Boolean(ua.match(/Android/i))
    const isIOS = Boolean(ua.match(/iPhone|iPad|iPod/i))
    const isMobile = Boolean(isAndroid || isIOS || ua.match(/Opera Mini/i) || ua.match(/IEMobile/i))
    const isDesktop = !isMobile

    setDevice({ isMobile, isDesktop, isAndroid, isIOS, userAgent: ua })
  }, [])

  return device
}

export const useMobile = (onChange?: (match: boolean) => void) => {
  const match = useMediaQuery({ maxWidth: 767 }, undefined, onChange)
  return match
}

export const useTablet = (onChange?: (match: boolean) => void) => {
  const match = useMediaQuery({ minWidth: 768, maxWidth: 991 }, undefined, onChange)
  return match
}

export const useDesktop = (onChange?: (match: boolean) => void) => {
  const match = useMediaQuery({ minWidth: 992 }, undefined, onChange)
  return match
}

export const Mobile = ({ children }: ResponsiveProps) => {
  const match = useMediaQuery({ maxWidth: 767 })
  return <>{match ? children : null}</>
}
export const Tablet = ({ children }: ResponsiveProps) => {
  const match = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return <>{match ? children : null}</>
}
export const Desktop = ({ children }: ResponsiveProps) => {
  const match = useMediaQuery({ minWidth: 992 })
  return <>{match ? children : null}</>
}